import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { AuthService } from '../../services/auth-service/auth.service';
import { DataLoginService as dataLogines } from '../../services/dataLogin/data-login.service';



@Component({
  selector: 'mg-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {


  constructor(
    private authService: AuthService,
    private fb: FormBuilder,
    private sericeDataLogin: dataLogines
  ) { }

  ngOnInit(): void {
  }


}
